<template>
<div class="chapter">
<div class="inner_page">
<h1>More English Fairy Tales</h1>
<h2 class="sigil_not_in_toc">Joseph Jacobs and John Dickson Batten</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?44153a2c